import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type RateConfirmationChangeEventPayloadFragment = (
  { readonly __typename?: 'RateConfirmationChangeEvent' }
  & Pick<TP.RateConfirmationChangeEvent, 'id' | 'type' | 'success'>
  & { routeVendorIdString: TP.RateConfirmationChangeEvent['routeVendorId'], rateConRouteId: TP.RateConfirmationChangeEvent['routeId'] }
);

export const RateConfirmationChangeEventPayloadFragmentDoc = gql`
    fragment RateConfirmationChangeEventPayload on RateConfirmationChangeEvent {
  id
  type
  routeVendorIdString: routeVendorId
  rateConRouteId: routeId
  success
}
    `;